import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Head from '../../components/Head/Head';
import PropertiesInMapComponent from '../../components/PageSections/PropertiesInMap';

const PropertiesInMap = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/propiedades/propiedades-en-mapa') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname]);

  return (
    <Fragment>
      <Head title="Propiedades en mapa" />

      <PropertiesInMapComponent />
    </Fragment>
  );
};

export default PropertiesInMap;
